module.exports = __webpack_public_path__ + "static/media/bird-silky-chicken3.e2f4fe8d.aac";